import { render, staticRenderFns } from "./SharedFeedbacks.vue?vue&type=template&id=302a5d7a&scoped=true"
import script from "./SharedFeedbacks.vue?vue&type=script&lang=js"
export * from "./SharedFeedbacks.vue?vue&type=script&lang=js"
import style0 from "./SharedFeedbacks.vue?vue&type=style&index=0&id=302a5d7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302a5d7a",
  null
  
)

export default component.exports